export default "__VITE_ASSET__FmkEUpaM__"